
let list = [
    {
        name: 'Birmingham.jpeg',
        title: `איתי ברמינגהאם`,
        address: 'פיירי סטריט 42, <br/> ברמינהגאם',
        addressNoHTML: 'פיירי סטריט 42, ברמינהגאם',
        coordinates: [52.382151, -1.987970],
        phoneNumber: '+44 121 692 1114'
    },
    {
        name: 'Edinburgh.jpg',
        title: `איתי אדינבורו`,
        address: '12 כיכר המרכז, <br/> אדינבורו',
        addressNoHTML: 'כיכר המרכז 12, אדינבורו',
        coordinates: [55.965476, -3.274018],
        phoneNumber: '+44 131 336 1157'
    },
    {
        name: 'Glasgow.jpg',
        title: `איתי גלאזגו`,
        address: 'דרך קרומדייל 10, <br/> פורט גלאזגו',
        addressNoHTML: 'דרך קרומדייל 10, פורט גלאזגו',
        coordinates: [55.919604, -4.657940],
        phoneNumber: '+44 141 204 2081'
    },
    {
        name: 'Liverpool.png',
        title: `איתי ליברפול`,
        address: 'בולד סטריט 85, <br/> ליברפול',
        addressNoHTML: 'בולד סטריט 85, ליברפול',
        coordinates: [53.402591, -2.976950],
        phoneNumber: '+44 151 230 8600'
    },
    {
        name: 'London.jpg',
        title: `איתי לונדון`,
        address: 'קרוס סטריט 60, <br/> לונדון',
        addressNoHTML: 'קרוס סטריט 60, לונדון',
        coordinates: [51.539520, -0.101495],
        phoneNumber: '+44 20 7434 1500'
    },
    {
        name: 'Manchester.jpg',
        title: `איתי מנצ'סטר`,
        address: `פורטלנד סטריט 101, <br/> מצנ'סטר`,
        addressNoHTML: `פורטלנד סטריט 101, מצנ'סטר`,
        coordinates: [53.477528, -2.239738],
        phoneNumber: '+44 161 694 8585'
    }]

export default list;